import { FC, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import {
  AdvancedMarker, 
  useAdvancedMarkerRef, 
  MapCameraChangedEvent,
  Map
} from '@vis.gl/react-google-maps';
import type { PlaceResult } from "components/GoogleMaps/PlaceAutocomplete";
import MapHandler from "components/GoogleMaps/MapHandler";
import { APIProvider } from '@vis.gl/react-google-maps';
import { GOOGLE_MAPS_API_KEY } from "data/constants";

interface AddressInputMiniMapProps {
  className?: string;
  defaultCenter: { lat: number; lng: number };
  place: PlaceResult;
}

const AddressInputMiniMap: FC<AddressInputMiniMapProps> = ({ 
    className = "",
    defaultCenter,
    place
}) => {

    const [markerRef, marker] = useAdvancedMarkerRef();
    const [currentCenter, setCurrentCenter] = useState<{ lat: number; lng: number }>({
        lat: defaultCenter.lat,
        lng: defaultCenter.lng,
    });
    
    const handleCameraChange = (event: MapCameraChangedEvent) => {
        const newCenter = event.map.getCenter();
        if (newCenter) {
            setCurrentCenter({ lat: newCenter.lat(), lng: newCenter.lng() });
        }
    }

    useEffect(() => {
        if (place && place.latitude && place.longitude) {
            setCurrentCenter({ lat: place.latitude, lng: place.longitude });
        }
    }, [place]);

    return (
        <div className={`w-full rounded-xl overflow-hidden ${className}`}>
            {
                (currentCenter.lat && currentCenter.lng) ?
                    <>
                        <APIProvider
                            apiKey={GOOGLE_MAPS_API_KEY} 
                            libraries={['maps']}
                            authReferrerPolicy="origin"
                            onError={(e) => console.error("Error loading Google Maps API", e)}
                            onLoad={() => console.log("Google Maps API loaded successfully")}
                        >
                            <Map
                                center={currentCenter}
                                defaultCenter={defaultCenter}
                                defaultZoom={10}
                                mapId="map-listing"
                                onCameraChanged={handleCameraChange}
                            >
                                { place && (
                                    <AdvancedMarker ref={markerRef} position={{
                                        lat: place.latitude, 
                                        lng: place.longitude
                                    }}/>
                                )}
                            </Map>
                            <MapHandler place={place} marker={marker} />
                        </APIProvider>
                    </>
                :
                    <div>
                        <Skeleton height={300} />
                    </div>
            }
        </div>
    );
};

export default AddressInputMiniMap;